(function ($) {
	$.fn.mapPin = function () {
		let $el = $(this);

		const init = function () {
			const $gallery = $el.find('.map-pin__gallery');

			if ($gallery.length > 0) {
				// const $gallery = $el.find('.map-pin__gallery');
				const $images = $gallery.find('img');
				let currentIndex = 0;

				setInterval(() => {
					// Hide the current image
					$images.eq(currentIndex).css({ opacity: 0 });

					// Calculate the index of the next image
					currentIndex = (currentIndex + 1) % $images.length;

					// Show the next image
					$images.eq(currentIndex).css({ opacity: 1 });
				}, 1000);
			}

			$el.on('click', function () {
				// add is-active class to the map-pin and remove it from the other map-pins
				$el.addClass('is-active').siblings().removeClass('is-active');
			});

			$el.on('mouseover', function () {
				if ($('#' + $(this).data('project-id')).length > 0) {
					$('#' + $(this).data('project-id')).addClass('map-pin-hover');
				}

				// ensure content is never overlaps the right edge of the .projects-map container
				const $map = $el.closest('.projects-map');
				const $content = $el.find('.map-pin__content');

				// get the right position of the map
				const mapOffset = $map.offset().left;
				const mapWidth = $map.outerWidth();
				const mapRightPosition = mapOffset + mapWidth;

				// get the right position of the content
				const pinOffset = $el.offset().left;
				const contentWidth = $content.outerWidth();
				const pinRightPosition = pinOffset + contentWidth;

				if (pinRightPosition > mapRightPosition) {
					// Reduce the width of the content so it fits within the map
					$content.css({
						maxWidth: mapRightPosition - pinOffset - 30,
					});
				}
			});

			$el.on('mouseleave', function () {
				if ($('#' + $(this).data('project-id')).length > 0) {
					$('#' + $(this).data('project-id')).removeClass('map-pin-hover');
				}
			});
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).mapPin();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.map-pin').mapPin();
	});
})(jQuery);
